var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { PaymentMethod } from '../../../core/reducers/financialCalculators';
import { filterSpecialPaymentOffers } from '../../SpecialOffers/utils/filterSpecialOffers';
import { getEmptyOfferCategory } from '../../SpecialOffers/utils/mapOffersToTrims';
export function checkThatTrimHasOffers(trim, paymentMethod) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!trim.offers)
        return false;
    return !!(((_b = (_a = trim.offers.incentiveOffers) === null || _a === void 0 ? void 0 : _a[paymentMethod]) === null || _b === void 0 ? void 0 : _b.length) ||
        ((_d = (_c = trim.offers.loyaltyOffers) === null || _c === void 0 ? void 0 : _c[paymentMethod]) === null || _d === void 0 ? void 0 : _d.length) ||
        ((_f = (_e = trim.offers.bonusOffers) === null || _e === void 0 ? void 0 : _e[paymentMethod]) === null || _f === void 0 ? void 0 : _f.length) ||
        ((_h = (_g = trim.offers.specialRateOffers) === null || _g === void 0 ? void 0 : _g[paymentMethod]) === null || _h === void 0 ? void 0 : _h.length));
}
export function mapOffersToModelsWithPrice(modelsWithPrice, offers) {
    if (!offers.length)
        return modelsWithPrice.map(function (trim) { return (__assign(__assign({}, trim), { offers: null })); });
    var offersMap = filterSpecialPaymentOffers(offers).reduce(function (map, offer) {
        if (!offer.transmissionKey)
            return map;
        map.set(offer.transmissionKey, offer);
        return map;
    }, new Map());
    return modelsWithPrice
        .map(function (trim) {
        var _a, _b, _c;
        var trimOffer = offersMap.get(trim.defaultTransmissionKey);
        var specialRateOffers = (_a = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.specialRateOffers) !== null && _a !== void 0 ? _a : getEmptyOfferCategory();
        return __assign(__assign({}, trim), { offers: {
                specialRateOffers: specialRateOffers,
                loyaltyOffers: (_b = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.loyaltyOffers) !== null && _b !== void 0 ? _b : getEmptyOfferCategory(),
                incentiveOffers: (_c = trimOffer === null || trimOffer === void 0 ? void 0 : trimOffer.incentiveOffers) !== null && _c !== void 0 ? _c : getEmptyOfferCategory(),
                bonusOffers: {
                    lease: trim.leaseBonusOffers.items,
                    finance: trim.financeBonusOffers.items,
                    cash: trim.cashBonusOffers.items,
                },
            } });
    })
        .map(function (trim) { return (__assign(__assign({}, trim), { offersPresent: {
            lease: checkThatTrimHasOffers(trim, PaymentMethod.lease),
            finance: checkThatTrimHasOffers(trim, PaymentMethod.finance),
            cash: checkThatTrimHasOffers(trim, PaymentMethod.cash),
        } })); });
}
